var styles = {"wrapper":"bc-select__wrapper","select":"bc-select__select","small":"bc-select__small","medium":"bc-select__medium","disabled":"bc-select__disabled","error":"bc-select__error"};

export { styles as default };
